import React from 'react';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { IReturnHeaderButtonHandlerProps } from '@src/models/common';

interface IReturnHeadersProps {
  showDivider?: boolean;
  title: string;
  isStepperFinished?: boolean;
  buttonHandlerFinished?: IReturnHeaderButtonHandlerProps;
  buttonHandlerUnfinished?: IReturnHeaderButtonHandlerProps;
}

export const ReturnHeaders = ({
  showDivider = false,
  title = '',
  isStepperFinished,
  buttonHandlerFinished,
  buttonHandlerUnfinished,
}: IReturnHeadersProps) => {
  return (
    <div
      className="sui-flex sui-flex-col sui-gap-4 sui-mb-8"
      data-testid="return-headers"
    >
      {showDivider && <hr />}
      <div className="sui-flex sui-justify-between sui-flex-row">
        <Typography weight="bold" variant="h2">
          {title}
        </Typography>
        {buttonHandlerUnfinished && !isStepperFinished && (
          <Link onClick={buttonHandlerUnfinished.buttonHandler}>
            {buttonHandlerUnfinished.buttonName}
          </Link>
        )}
        {buttonHandlerFinished && isStepperFinished && (
          <Link onClick={buttonHandlerFinished.buttonHandler}>
            {buttonHandlerFinished.buttonName}
          </Link>
        )}
      </div>
    </div>
  );
};
